import { render, staticRenderFns } from "./DashboardTreeSelect.vue?vue&type=template&id=b6f82782&"
import script from "./DashboardTreeSelect.vue?vue&type=script&lang=js&"
export * from "./DashboardTreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports